import { render, staticRenderFns } from "./SalesInvoiceStatement.vue?vue&type=template&id=70c4ab63"
import script from "./SalesInvoiceStatement.vue?vue&type=script&lang=js"
export * from "./SalesInvoiceStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports